import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import DesignationForm from '../components/forms/DesignationForm';
import '../styles/EmployeeMaster.css';
import DesignationTable from '../components/DesignationTable';

const DesignationModel = () => {
     const navigate = useNavigate();
     const location = useLocation();

     const showModal = location.pathname === '/designation/add';

     const handleAddClick = () => {
          navigate('/designation/add');
     };

     const handleCloseModal = () => {
          navigate('/designation');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Designation Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Designation
                    </button>
               </div>

               <DesignationTable />

               <Modal
                    show={showModal}
                    onHide={handleCloseModal}
                    size="md"
                    centered
               >
                    <Modal.Header closeButton>
                         <Modal.Title>Add New Designation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <DesignationForm />
                    </Modal.Body>
                    <Modal.Footer>
                         <Button variant="secondary" onClick={handleCloseModal}>
                              Close
                         </Button>
                         <Button variant="primary">
                              Save
                         </Button>
                    </Modal.Footer>
               </Modal>
          </div>
     );
};

export default DesignationModel;